export default __webpack_public_path__ + "static/media/8.2f9259db.png";